import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Alert, Button, Collapse, Container, Form, Nav, Navbar, Spinner } from 'react-bootstrap';
import { RouterProvider, createBrowserRouter, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LoginPageWithUserDetail } from './components/LoginPageWithUserDetail';
import React from 'react';
import ReactGA from "react-ga4" ;
import { jwtDecode } from 'jwt-decode';
import CustomerVehicleDetail from './components/CustomerVehicleDetail';
import { CustomerDriverDetail } from './components/CustomerDriverDetail';
import { CustomerVehicleDetailPart } from './components/CustomerVehicleDetailPart';
import Clock from './components/Clock';
import ComplaintPage from './components/ComplaintPage';
import { ResetPasswordPage } from './components/ResetPasswordPage';
import DriverRegistrationPage from './components/DriverRegistrationPage';
export const MainContext = React.createContext();

ReactGA.initialize("G-YL3G85X4DV");

const router = createBrowserRouter([
  {
    path: "/sikayet",
    element: <ComplaintPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/driver-registration",
    element: <DriverRegistrationPage />,
  },
  {
    path: "/",
    element: <LoginPageWithUserDetail />,
  },
  {
    path: "/vehicleDetail/:id",
    element: <CustomerVehicleDetail />,
  },
  {
    path: "/driverDetail",
    element: <CustomerDriverDetail />,
  },
  {
    path: "/vehicleDetailPart",
    element: <CustomerVehicleDetailPart />,
  }
]);

const App = () => {
  var [accessToken, setAccessToken] = useState('');
  var [sasToken, setSasToken] = useState('');
  var [progress, setProgress] = useState(false);
  var [errorMessage, setErrorMessage] = useState('');
  const [reactGa] = useState(ReactGA);
  const [darkMode, setDarkMode] = useState(true);
  const [timeoutId, setTimeoutId] = useState('');
  const [signedInUserEmail, setSignedInUserEmail] = useState('');
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [projectLogo, setProjectLogo] = useState('');
  const [projectName, setProjectName] = useState('');

  // Listen for route changes
  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen to popstate for browser back/forward
    window.addEventListener('popstate', handleLocationChange);

    // Also check on mount and periodically (for programmatic navigation)
    const interval = setInterval(handleLocationChange, 100);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      clearInterval(interval);
    };
  }, []);

  // Check if current path is a public route (no auth required)
  const isPublicRoute = () => {
    const publicRoutes = ['/sikayet', '/reset-password', '/driver-registration'];
    return publicRoutes.includes(currentPath);
  };

  // Check if current path is the GPS vehicle detail page
  const isVehicleDetailPage = () => {
    return currentPath.startsWith('/vehicleDetail/');
  };

  const clearErrorMessage = () => setErrorMessage("");
  const setCurrentErrorMessageWithTimeout = (err) => {
    clearErrorMessage();
    clearTimeout(timeoutId);
    if (err.status === 401)
    {
      setErrorMessage('Kullanıcı adı veya şifre hatalı. Lütfen tekrar deneyiniz.');
    }
    else
    {
      setErrorMessage('Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
    }

    var timeout = setTimeout(clearErrorMessage, 7000);
    setTimeoutId(timeout.toString());
  }

  useEffect(() => {
    document.body.setAttribute('data-bs-theme', 'dark');
  }, []);

  useEffect(() => {
    // Get once from localStorage
    var token = localStorage.getItem('kentist-musteri-accessToken') ?? '';
    if (token === '')
    {
      return;
    }

    var decodedToken = jwtDecode(token);
    var date = new Date();
    // console.log(decodedToken.exp, (date.getTime() + 5 * 60 * 1000) / 1000)
    // below code is checking if token is greater than current time + 5mins
    if (decodedToken.exp > ((date.getTime() + 5 * 60 * 1000) / 1000))
    {
      setAccessToken(token);
    }
  }, []);

  useEffect(() => {
    if (accessToken)
    {
      let decoded = jwtDecode(accessToken);
      setSignedInUserEmail(decoded?.email);
    }
  }, [accessToken]);

  useEffect(() => {
    if (accessToken)
      clearErrorMessage();
  }, [accessToken])

  const handleLogout = () => {
    localStorage.removeItem('kentist-musteri-accessToken');
    setAccessToken('');
  }

  return (
      <MainContext.Provider value={{
        accessToken: accessToken,
        setAccessToken: setAccessToken,
        darkMode: darkMode,
        sasToken: sasToken,
        setSasToken: setSasToken,
        setProgress: setProgress,
        progress: progress,
        setErrorMessage: setCurrentErrorMessageWithTimeout,
        reactGa: reactGa,
        signedInUserEmail: signedInUserEmail,
        projectLogo: projectLogo,
        setProjectLogo: setProjectLogo,
        projectName: projectName,
        setProjectName: setProjectName
      }}>
        <div className='fade' style={{height: '100%', opacity: progress ? 0.5 : 1}}>
          {progress ? <div className='spinner'><Spinner animation="border" style={{ borderColor: '#14345c', borderRightColor: 'transparent' }} /></div> : null}
          {accessToken && !isVehicleDetailPage() ? (
            <Navbar collapseOnSelect expand="lg" style={{ background: "#000000", borderBottom: "2px solid rgba(20, 52, 92, 0.6)", boxShadow: "0 4px 20px rgba(20, 52, 92, 0.4)" }}>
              <Navbar.Brand href="/" className="custom-navbar" style={{backgroundColor: 'transparent', marginLeft: 10, filter: "drop-shadow(0 0 10px rgba(20, 52, 92, 0.4))", display: 'flex', alignItems: 'center', gap: '15px'}}>
              <div style={{
                  background: 'white',
                  padding: '4px 10px',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <img
                    src={`${process.env.PUBLIC_URL}/kentist-logo.png`}
                    alt="Kentist Turizm"
                    style={{width: '120px' }}
                  />
                </div>
              {projectLogo && sasToken && (
                <>
                  <span style={{ color: 'rgba(90, 155, 212, 0.6)', fontSize: '24px', fontWeight: '300' }}>|</span>
                  <img
                    src={projectLogo + sasToken}
                    alt={projectName}
                    style={{
                      height: '40px',
                      maxWidth: '120px',
                      objectFit: 'contain',
                      borderRadius: '5px'
                    }}
                  />
                </>
              )}
            </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <div className="w-100 d-flex justify-content-between">
                  <Nav className='me-auto'></Nav>
                  {accessToken ? <div style={{marginRight: '10px'}}><Clock /></div> : null}
                  {accessToken ? <Button size="sm" onClick={() => handleLogout()} style={{marginRight: 10, background: "linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)", border: "none", color: "#fff", fontWeight: "700", boxShadow: "0 2px 10px rgba(20, 52, 92, 0.5)"}}>Çıkış yap</Button> : null}
                </div>
              </Navbar.Collapse>
            </Navbar>
          ) : null}

            <Collapse in={errorMessage !== ''}>
              <div>
                <Alert dismissible variant='danger' onClose={() => clearErrorMessage()}>
                  {errorMessage}
                </Alert>
              </div>
            </Collapse>
              {accessToken || isPublicRoute() ? <div className="main-content-vip" style={{height: '100%', minHeight: '100vh'}}><RouterProvider router={router} /></div> : <LoginPageWithUserDetail />}
        </div>
      </MainContext.Provider>
  );
}

export default App;
